"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/shared/components/common/carousel";
import List from "@/shared/components/common/List";
import type { TourImage } from "@/types/services/tour/apis/Availability";
import { CaretLeft } from "@phosphor-icons/react";
import Image from "next/image";
import { type MouseEvent, useMemo } from "react";

interface TourCardCarouselProps {
  images: TourImage[];
  slug: string;
}

export default function TourCardCarousel({
  images,
  slug,
}: TourCardCarouselProps) {
  const memoizedimages = useMemo(
    () =>
      images
        .map((img) => ({ ...img, id: img.path }))
        .filter((img) => img.type === "thumbnail" && img.path),
    [images],
  );

  const handleOnCarouselClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Carousel
      dir={"ltr"}
      orientation="horizontal"
      className="md:max-w-60 md:min-w-60 group"
      onClick={handleOnCarouselClick}
    >
      <CarouselContent className="h-44 mx-auto rounded-md  gap-x-2">
        <List
          items={memoizedimages}
          renderItems={({ path, id }) => (
            <CarouselItem key={id} className="relative">
              <Image
                quality={75}
                className="rounded-md object-cover"
                loading="lazy"
                fill
                src={path}
                alt={slug}
              />
            </CarouselItem>
          )}
        />
      </CarouselContent>

      <CarouselPrevious
        className="!w-7 !h-7 max-lg:hidden !p-0 absolute left-[2%] !bg-black text-white opacity-0 hover:!text-white group-hover:opacity-70 border-none !rounded-full "
        icon={<CaretLeft size={18} weight="regular" />}
      />
      <CarouselNext className="!w-7 !h-7 max-lg:hidden absolute right-[2%] !bg-black text-white opacity-0 hover:!text-white group-hover:opacity-70 border-none !rounded-full " />
    </Carousel>
  );
}
